import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { Grid } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { BlobProvider } from '@react-pdf/renderer';
import Document from 'components/Document';
import messages from 'containers/TransactionManagerTimeLine/OfferRegulation/messages';
import ReceiptDocument from 'containers/TransactionManagerTimeLine/OfferRegulation/documents/ReceiptDocument';
import ReceiptDocumentVictim from 'containers/TransactionManagerTimeLine/OfferRegulation/documents/ReceiptDocumentVictim';
import { translate } from 'containers/services/translate';

export interface documentTransactionProps {
  intl: IntlShape;
  body: any;
}

const DocumentTransaction: React.FC<documentTransactionProps> = (
  props,
): JSX.Element => {
  return (
    <Grid>
      <Document
        name={translate(messages.downloadDocumentReciept, props)}
        type={'RECEIPT'}
        icon={
          <BlobProvider
            document={
              (<ReceiptDocument intl={props.intl} body={props.body} />) as any
            }
          >
            {params => {
              return (
                <a
                  href={params.url ? params.url : ''}
                  target="_blank"
                  rel="noreferrer"
                >
                  <VisibilityIcon
                    style={{ color: 'black' }}
                    className="consult"
                  />
                </a>
              );
            }}
          </BlobProvider>
        }
      />
      <Document
        name={translate(messages.downloadDocumentReciept, props) + '2'}
        type={'RECEIPT 2'}
        icon={
          <BlobProvider
            document={
              (
                <ReceiptDocumentVictim intl={props.intl} body={props.body} />
              ) as any
            }
          >
            {params => {
              return (
                <a
                  href={params.url ? params.url : ''}
                  target="_blank"
                  rel="noreferrer"
                >
                  <VisibilityIcon
                    style={{ color: 'black' }}
                    className="consult"
                  />
                </a>
              );
            }}
          </BlobProvider>
        }
      />
    </Grid>
  );
};
export default injectIntl(DocumentTransaction);
